module.exports = __webpack_public_path__ + "img/total-points-bg.81eeda3e.png";